import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../hooks/useAuth';


const PrivateAdminRoute = () => {
  const { isAuthenticated } = useAuth();

  // Check if user is not logged in
  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  //   // Check if user is not an admin
  //   if (user?.role !== 'admin') {
  //     return <Navigate to="/unauthorized" replace />;
  //   }

  // Render nested admin routes
  return <Outlet />;
};

export const PublicAdminRoute = () => {
  const { isAuthenticated } = useAuth();
  console.log(isAuthenticated, "isAuthenticated");
  

  // Check if user is not logged in
  if (isAuthenticated) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  //   // Check if user is not an admin
  //   if (user?.role !== 'admin') {
  //     return <Navigate to="/unauthorized" replace />;
  //   }

  // Render nested admin routes
  return <Outlet />;
};

export default PrivateAdminRoute;
